export { default } from './ChargerSlider';
